import { FC } from 'react'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import styled from 'styled-components'

const SmallMultipleComponent: FC<{
  headlineGrid?: string
  leadGrid?: string
  dwSourceUrl: string[]
  dwTitles: string[]
  dwDescriptions: string[]
  number: string[]
  altitude: string[]
  iFrameStyleHeight?: string
  gridColumnsDesktop?: number;
  gridColumnsMobile?: number;
  columnGapDesktop?: string
  columnGapMobile?: string
  colorMode?: "light" | "dark"
  caption?: string
  source?: string
}> = ({
  headlineGrid,
  leadGrid,
  dwSourceUrl,
  dwTitles,
  dwDescriptions,
  number,
  altitude,
  iFrameStyleHeight,
  gridColumnsDesktop,
  gridColumnsMobile,
  columnGapDesktop,
  columnGapMobile,
  colorMode,
  caption,
  source,
}) => {
  return (
    <>
      <Grid
        gridColumnsDesktop={typeof gridColumnsDesktop === 'string' ? parseInt(gridColumnsDesktop, 10) : gridColumnsDesktop}
        gridColumnsMobile={typeof gridColumnsMobile === 'string' ? parseInt(gridColumnsMobile, 10) : gridColumnsMobile}
        columnGapDesktop={columnGapDesktop}
        columnGapMobile={columnGapMobile}
        className={caption || source ? 'captionTrue' : 'captionFalse'}
      >
        {dwSourceUrl &&
          dwSourceUrl.map((itemSourceUrl: string, sourceUrlKey: number) => {
            return (
              <Item key={sourceUrlKey}>
                <TitleWrapper>
                  {dwTitles && (
                    <Title
                      className={Number(gridColumnsMobile) > 1 ? 'small' : ''}
                      colorMode={colorMode === 'dark' ? 'dark' : 'light'}
                    >
                      <div>{dwTitles[sourceUrlKey]}</div>
                      <div className='light'>{altitude[sourceUrlKey]}</div>
                    </Title>
                  )}
                  {dwDescriptions && (
                    <Description
                      className={Number(gridColumnsMobile) > 1 ? 'small' : ''}
                    >
                      {number[sourceUrlKey] && (
                        <span className='number'>{number[sourceUrlKey]}</span>
                      )}
                      {dwDescriptions[sourceUrlKey]}
                    </Description>
                  )}
                </TitleWrapper>
                <AutofitIFrame
                  src={itemSourceUrl + '?dark=' + String(colorMode === 'dark')}
                  style={{
                    height: iFrameStyleHeight && iFrameStyleHeight,
                    minHeight: iFrameStyleHeight && iFrameStyleHeight,
                  }}
                />
              </Item>
            )
          })}
      </Grid>

      <>
        {(caption || source) && (
          <Caption
            className={caption || source ? 'captionTrue' : 'captionFalse'}
          >
            {' '}
            {caption}
            {source && <Source>{source}</Source>}
          </Caption>
        )}
      </>
    </>
  )
}
const Grid = styled.div<{
  gridColumnsDesktop?: number
  gridColumnsMobile?: number
  columnGapDesktop?: string
  columnGapMobile?: string
}>`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-top: 2rem;
  display: grid;
  grid-template-columns: repeat(
    ${({ gridColumnsDesktop }) => gridColumnsDesktop},
    1fr
  );
  grid-column-gap: ${({ columnGapDesktop }) => columnGapDesktop};
  grid-row-gap: 1rem;
  &&.captionFalse {
    margin-bottom: 3rem;
    @media only screen and (min-width: 832px) {
      margin-bottom: 5rem;
    }
  }
  @media only screen and (max-width: 641px) {
    grid-row-gap: 0.5rem;
    grid-template-columns: repeat(
      ${({ gridColumnsMobile }) => gridColumnsMobile},
      1fr
    );
    grid-column-gap: ${({ columnGapMobile }) => columnGapMobile};
  }
  @media only screen and (max-width: 350px) {
    grid-row-gap: 0.5rem;
    grid-template-columns: repeat(1, 1fr);
    grid-column-gap: ${({ columnGapMobile }) => columnGapMobile};
  }
`
const Item = styled.div`
  /* height: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  height: 100%;
`
const Title = styled.div<{ colorMode: "light" | "dark" }>`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  font-family: var(--font-sans-serif);
  font-size: 1em;
  font-weight: 700;
  line-height: 24px;
  margin: 0 0 7px;
  color: ${(props) => (props.colorMode === "dark" ? "var(--gray-6)" : "var(--text-color)")};
  .light {
    font-weight: 300;
    white-space: nowrap;
    padding-left: 0.25rem;
  }
  border-bottom: 1px solid ${(props) => (props.colorMode === "dark" ? "var(--gray-6)" : "var(--text-color)")};
  padding-bottom: 2px;

  /* @media only screen and (min-width: 642px) and (max-width: 711px) {
    .light {
      font-size: 0.9em;
    }
    &.small {
      font-size: 0.85em;
      margin: 0 0 18px;
    }
  } */

  @media only screen and (max-width: 711px) {
    .light {
      font-size: 0.9em;
      /* line-height: 1.5em; */
    }
    &.small {
      font-size: 0.85em;
      margin: 0 0 6px;
    }
  }
`

const Description = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 0.85em;
  margin: 0 0 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  .number {
    background-color: #d3343f;
    /* border-radius: 3px; */
    color: #fff;
    font-weight: 600;
    padding: 0.1rem 0.5rem 0.15rem 0.5rem;
    margin-right: 0.5rem;
  }
  @media only screen and (max-width: 711px) {
    &.small {
      font-size: 0.75em;
      margin: 0 0 18px;
    }
  }
`

const Caption = styled.figcaption`
  color: var(--text-color);
  font-family: var(--font-sans-serif);
  font-size: 1.5rem;
  line-height: 2.1rem;
  /* padding: 1.5rem 0 0; */
  /* @media only screen and (max-width: 711px) {
    &&.ContentWidth {
      padding: 1.5rem 18px 0 18px;
    }
  } */
  &&.captionTrue {
    margin-bottom: 3rem;
    @media only screen and (min-width: 832px) {
      margin-bottom: 5rem;
    }
  }
`
const Source = styled.div`
  padding-top: 0.3rem;
  font-weight: 400;
  color: var(--gray-3);
  font-size: 1.2rem;
  line-height: 1.8rem;
`

export default SmallMultipleComponent
